import React, { useEffect } from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IThemePreviewATProps extends IBaseElementProps {}

const ThemePreviewAT: React.FC = () => {
	useEffect(() => {
		document.documentElement.classList.add(
			'calian-theme-advanced-technologies',
		);
	}, []);

	return (
		<div className="calian-theme-preview">
			<div className="container-fluid mw-1440px">
				<div className="row">
					<div className="col-12 mx-auto py-5">
						<h1 className="text-center">
							AT Space and Terrestrial Theme Preview
						</h1>
					</div>
				</div>
				<div className="row py-5">
					<div className="col-6 col-md-4 mb-4 d-flex justify-content-center">
						<button type="button" className="btn btn-primary">
							Primary
						</button>
					</div>
					<div className="col-6 col-md-4 mb-4 d-flex justify-content-center">
						<button type="button" className="btn btn-secondary">
							Secondary
						</button>
					</div>
					<div className="col-6 col-md-4 mb-4 d-flex justify-content-center">
						<button type="button" className="btn btn-success">
							Success
						</button>
					</div>
					<div className="col-6 col-md-4 mb-4 d-flex justify-content-center">
						<button type="button" className="btn btn-info">
							Info
						</button>
					</div>
					<div className="col-6 col-md-4 mb-4 d-flex justify-content-center">
						<button type="button" className="btn btn-warning">
							Warning
						</button>
					</div>
					<div className="col-6 col-md-4 mb-4 d-flex justify-content-center">
						<button type="button" className="btn btn-danger">
							Danger
						</button>
					</div>
					<div className="col-6 col-md-4 mb-4 d-flex justify-content-center">
						<button type="button" className="btn btn-light">
							Light
						</button>
					</div>
					<div className="col-6 col-md-4 mb-4 d-flex justify-content-center">
						<button type="button" className="btn btn-dark">
							Dark
						</button>
					</div>
				</div>
				<div className="row">
					<div className="col-12 py-5">
						<div className="row">
							<div className="col color-swatch">
								<p className="mb-0">Primary</p>
								<div className="bg-primary text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
								<p className="mb-2">#4538D8</p>
							</div>
							<div className="col color-swatch">
								<p className="mb-0">Secondary</p>
								<div className="bg-secondary text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
								<p className="mb-2">#080A39</p>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<p className="mb-0">Gradient Swatches</p>
								<div className="row">
									<div className="col color-swatch">
										<div className="bg-gradient-color-1 text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
										<p className="mb-2">#3E0EA5</p>
									</div>
									<div className="col color-swatch">
										<div className="bg-gradient-color-2 text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
										<p className="mb-2">#080A39</p>
									</div>
								</div>
							</div>
							<div className="col">
								<p className="mb-0">Gradient Swatches</p>
								<div className="row">
									<div className="col color-swatch">
										<div className="bg-gradient-color-3 text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
										<p className="mb-2">#3651B3</p>
									</div>
									<div className="col color-swatch">
										<div className="bg-gradient-color-4 text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
										<p className="mb-2">#080A39</p>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col color-swatch">
								<p className="mb-0">Radial Gradient</p>
								<div className="theme-bg-radial-gradient-one text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
							</div>
							<div className="col color-swatch">
								<p className="mb-0">Linear Gradient</p>
								<div className="theme-bg-linear-gradient-one text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
							</div>
							<div className="col color-swatch">
								<p className="mb-0">Radial Gradient</p>
								<div className="theme-bg-radial-gradient-two text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
							</div>
							<div className="col color-swatch">
								<p className="mb-0">Linear Gradient</p>
								<div className="theme-bg-linear-gradient-two text-white p-4 rounded min-height-150px d-flex align-items-center justify-content-center"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ThemePreviewAT;
